var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row pfol__entry" },
    [
      _c("div", { staticClass: "small-12" }, [
        _c(
          "div",
          { staticClass: "submissions__topbar" },
          [
            _c(
              "Sticky",
              {
                attrs: { align: "right", stickyTop: 40, specifyWidth: "auto" },
              },
              [
                _vm.showStartBtn
                  ? _c(
                      "HKLButton",
                      {
                        attrs: { color: "orange" },
                        on: { click: _vm.startPostFitOutClick },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("tenantProjects.postFitout.startBtn")
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.curReviewerWithAccess
                  ? _c("HKLButton", {
                      attrs: { action: "save", color: "darkblue" },
                      on: {
                        click: function () {
                          return _vm.save()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPreviewSend
                  ? _c("HKLButton", {
                      attrs: { action: "preview_send", color: "orange" },
                      on: { click: _vm.previewSave },
                    })
                  : _vm.showPreviewPreview
                  ? _c("HKLButton", {
                      attrs: { action: "preview", color: "orange" },
                      on: { click: _vm.previewSave },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showNextReviewerBtn
                  ? _c("HKLButton", {
                      attrs: { action: "nextReviewer", color: "orange" },
                      on: { click: _vm.nextReviewerClick },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isTenant
        ? _c(
            "div",
            { staticClass: "small-12" },
            [
              _c("TenantPostFitOutComment", {
                ref: "refTenantPostFitOutComments",
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEngineer
        ? [
            _vm.showCommentsTab
              ? _c("div", { class: { "small-6": _vm.showCommentsTab } }, [
                  _c(
                    "div",
                    { staticClass: "pfol-container__comment" },
                    [
                      _c("PostFitOutComments", {
                        ref: "refPostFitOutComments",
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: [_vm.showCommentsTab ? "small-6" : "small-12"] },
              [
                _c(
                  "div",
                  { staticClass: "pfol-container__guideline" },
                  [_c("PostFitOutGuidelineSelector")],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("PostFitOutNextReviewer", { ref: "nextReviewerModal" }),
            _vm._v(" "),
            _vm.showPreviewSend || _vm.showPreviewPreview
              ? _c("PostFitOutPreviewSendModal", { ref: "previewSendModal" })
              : _vm._e(),
            _vm._v(" "),
            _c("HKLModal", {
              ref: "msgModalForFinalInspModalRef",
              attrs: { closable: true, hasCancelBtn: false },
              on: { onOkClick: _vm.openEditModals },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "tenantProjects.postFitout.cannotStartHint_1"
                              )
                            )
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "tenantProjects.postFitout.cannotStartHint_2",
                                [_vm.$t("action.ok")]
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                787800528
              ),
            }),
            _vm._v(" "),
            _c(
              "Provider",
              [
                _c("EditInspectionModal", {
                  ref: "editPopup",
                  attrs: { afterSaved: _vm.saveSendCallback },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }